import React from 'react'
import { Avatar } from '@material-tailwind/react'
import { ChevronRightIcon } from '@heroicons/react/24/outline'

interface TestimonialProps {
  testimonial: {
    content: string
    avatar: string
    fullName: string
    role: string
    company: string
    youtubeUrl: string
  }
}

export const Testimonial = ({
  testimonial: { company, avatar, fullName, role, content, youtubeUrl },
}: TestimonialProps) => (
  <article className="flex flex-col justify-end px-4 py-4 space-y-4 text-lg font-thin border rounded-lg border-primary text-night">
    <div className="h-full">
      <p>{content}</p>
    </div>
    <div className="flex items-center space-x-4 space-y-2">
      {avatar && <Avatar src={avatar} alt={`Portrait de ${fullName}`} />}
      <div>
        <h3 className="text-xl font-normal text-primary">{fullName}</h3>
        <p>
          {role} chez {company}
        </p>
      </div>
    </div>

    {youtubeUrl && (
      <div>
        <a
          href={youtubeUrl}
          target="_blank"
          rel="sponsored noreferrer"
          className="flex items-center mt-2 space-x-2 font-normal"
        >
          <span>Témoignage vidéo</span>
          <ChevronRightIcon className="w-5 h-5 text-night" />
        </a>
      </div>
    )}
  </article>
)
